import React, { FC, useContext } from 'react'

import AngleLeft from '@Assets/SVG/AngleLeft'
import AngleRight from '@Assets/SVG/AngleRight'
import { SliderContext } from '@Components/Product/Slider/Context/SliderContext'

import styles from './SliderControls.module.scss'

const SliderControls: FC = () => {
  const {
    goToNextSlide,
    goToPreviousSlide,
    isFullscreen,
    slides,
  } = useContext(SliderContext)

  if (slides.length === 1) {
    return null
  }

  return (
    <>
      <button
        aria-label="Previous"
        className={`${styles.button} ${styles.prev} ${isFullscreen ? styles.fullscreen : ''}`}
        onClick={() => goToPreviousSlide(true)}
        type="button"
      >
        <AngleLeft className={styles.icon} />

      </button>

      <button
        aria-label="Next"
        className={`${styles.button} ${styles.next} ${isFullscreen ? styles.fullscreen : ''}`}
        onClick={() => goToNextSlide(true)}
        type="button"
      >
        <AngleRight className={styles.icon} />
      </button>
    </>
  )
}

export default SliderControls
